document.addEventListener("DOMContentLoaded", () => {
  const body = document.getElementById("size-chart-body");
  const tabs = document.querySelectorAll(".tab-btn");
  const pages = document.querySelectorAll(".tab-page");
  const container = document.querySelector(".tab-container");
  const trackEl = document.querySelector(".tab-track");

  let activePage = document.getElementById("charts");
  let unit = "cm";
  let isAnimating = false;

  if (trackEl) trackEl.style.position = "relative";
  pages.forEach((p) => {
    p.style.position = "absolute";
    p.style.inset = "0";
    p.style.width = "100%";
    p.style.boxSizing = "border-box";
    p.style.display = p === activePage ? "block" : "none";
  });
  if (activePage) activePage.classList.add("active");
  if (container) {
    container.style.transition = "height 0.6s cubic-bezier(0.4,0,0.2,1)";
  }
  function updateContainerHeight(el = activePage) {
    if (!container || !el) return;
    container.style.height = el.scrollHeight + "px";
  }
  updateContainerHeight();

  const measurementNotes = {
    manual: "All sizes are garment measurements taken flat; 1-3 cm difference may occur.",
    shoulder: "Distance between shoulder points.",
    length: "Vertical length from shoulder to hem.",
    bust: "Measured horizontally 1cm below the armhole.",
    waist: "Measured horizontally at the waistline.",
    hip: "Measured horizontally at the fullest part of the garment.",
    hem: "Width across the bottom hem.",
    sleeve: "From shoulder point to sleeve opening. Raglan: from back neck point to sleeve opening.",
    armhole: "Vertical distance from shoulder point to armhole point.",
    thigh: "Width of thigh measured flat.",
    cuff: "Width across the cuff.",
    pantlength: "From waist to hem along the side seam.",
    inseam: "From crotch to hem along inside leg.",
    outseam: "From waist to hem along outside leg.",
    rise: "From crotch seam to top of waistband.",
    backlength: "From back neck point to waistline.",
    legopening: "Width across the leg opening.",
    bwh: "Model's bust / waist / hip."
  };

  function generateMeasurementNote(headers, isModel = false) {
    const lowerHeaders = headers.map((h) => h.toLowerCase().replace(/\s+/g, ""));
    const notes = [];

    if (!isModel && measurementNotes.manual) {
      notes.push(`<span style="color:#000;">Note:</span> ${measurementNotes.manual}`);
    }

    lowerHeaders.forEach((h, i) => {
      if (measurementNotes[h]) {
        const originalHeader = headers[i].trim();
        notes.push(`<span style="color:#000;">${originalHeader}:</span> ${measurementNotes[h]}`);
      }
    });

    if (isModel) {
      if (
        lowerHeaders.includes("bwh") ||
        lowerHeaders.includes("b/w/h") ||
        lowerHeaders.includes("bust") ||
        lowerHeaders.includes("waist") ||
        lowerHeaders.includes("hip") ||
        lowerHeaders.includes("bust/waist/hip") ||
        lowerHeaders.includes("bust/waist/hips")
      ) {
        notes.push(`<span style="color:#000;">BWH:</span> ${measurementNotes.bwh}`);
      }
    }

    return notes.length ? `<div class="size-note">${notes.join("<br>")}</div>` : "";
  }

  // =========================
  // ✅ helpers（新增：区间解析 + cm/ftin + kg/lbs + 斤处理）
  // =========================
  const dashNormalize = (s) => String(s || "").replace(/–/g, "-").trim();

  const parseRangeOrNumber = (s) => {
    const t = dashNormalize(s).replace(/\s+/g, "");
    if (/^\d+(\.\d+)?-\d+(\.\d+)?$/.test(t)) {
      const [a, b] = t.split("-").map(Number);
      if (!isNaN(a) && !isNaN(b)) return { type: "range", a, b };
    }
    const num = parseFloat(t);
    if (!isNaN(num)) return { type: "single", a: num };
    return null;
  };

  const cmToFtIn = (cm) => {
    const totalIn = Math.round(cm / 2.54);
    const ft = Math.floor(totalIn / 12);
    const inch = totalIn % 12;
    return `${ft}'${inch}"`;
  };

  const cmRangeToFtInRange = (a, b) => `${cmToFtIn(a)}-${cmToFtIn(b)}`;

  const cmToIn = (cm) => (cm / 2.54).toFixed(1);
  const cmRangeToInRange = (a, b) => `${cmToIn(a)}-${cmToIn(b)}`;

  const normalizeWeightKg = (val, hasExplicitKg) => {
    // 没写 kg/lbs，并且数值很大，默认按“斤”处理
    if (!hasExplicitKg && val > 70) return val / 2;
    return val;
  };

  const kgToLbs = (kg) => Math.round(kg * 2.20462);

  // =========================
  // ✅ 表头 meta（保留你原结构，只增强）
  // =========================
  function thWithMeta(h) {
    const raw = (h || "").trim();
    const hl = raw.toLowerCase();
    let kind = "len"; // 默认长度
    if (hl.includes("weight")) kind = "weight";
    else if (hl.includes("height")) kind = "height";
    else if (hl.includes("bust") || hl.includes("waist") || hl.includes("hip")) kind = "len";
    return `<th data-raw="${raw.replace(/"/g, "&quot;")}" data-kind="${kind}">${raw}</th>`;
  }

  // =========================
  // ✅ drawer open/close（你原逻辑）
  // =========================
  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("#open-size-chart");
    const closeBtn = e.target.closest("#close-size-chart, #close-size-chart-back");
    const overlay = e.target.closest("#size-chart-overlay");

    const drawer = document.getElementById("size-chart-drawer");
    const overlayEl = document.getElementById("size-chart-overlay");

    if (!drawer || !overlayEl || !body) return;

    if (openBtn) {
      drawer.classList.add("open");
      overlayEl.classList.add("open");
      renderSizeChart();
      requestAnimationFrame(() => updateContainerHeight());
    }

    if (closeBtn || overlay) {
      drawer.classList.remove("open");
      overlayEl.classList.remove("open");
    }
  });

  function renderSizeChart() {
    const raw = body.dataset.raw;
    if (!raw) return;

    const sections = raw
      .split(/\n\s*\n/)
      .map((s) => s.trim())
      .filter(Boolean);

    body.innerHTML = `
      <div style="margin-bottom: 16px;">
        <div style="display:flex; border:1px solid #ccc; width:200px;">
          <button id="btn-cm" class="active" style="flex:1; padding:6px; border:none; cursor:pointer; background:#000; color:#fff;">CM</button>
          <button id="btn-inch" style="flex:1; padding:6px; border:none; cursor:pointer; background:#fff; color:#000;">INCH</button>
        </div>
      </div>
    `;

    sections.forEach((section) => {
      const lines = section.split("\n").map((l) => l.trim()).filter(Boolean);
      const firstLine = (lines[0] || "").toLowerCase();

      if (firstLine.includes("try-on")) {
        body.insertAdjacentHTML("beforeend", renderModelTable(lines, true));
      } else if (firstLine.includes("recommendation")) {
        body.insertAdjacentHTML("beforeend", renderRecommendationTable(lines));
      } else if (
        firstLine.includes("model") ||
        firstLine.includes("height") ||
        firstLine.includes("weight")
      ) {
        body.insertAdjacentHTML("beforeend", renderModelTable(lines, false));
      } else {
        body.insertAdjacentHTML("beforeend", renderSizeTable(lines[0], lines));
      }
    });

    const btnCm = document.getElementById("btn-cm");
    const btnInch = document.getElementById("btn-inch");
    if (btnCm && btnInch) {
      btnCm.addEventListener("click", () => switchUnit("cm"));
      btnInch.addEventListener("click", () => switchUnit("in"));
    }

    updateContainerHeight();
  }

  // =========================
  // ✅ renderSizeTable：td 渲染升级（支持 weight/height 区间）
  // =========================
  function renderCellByHeader(rawValue, headerText) {
    const header = (headerText || "").toLowerCase();
    const raw = String(rawValue || "").trim();

    // 规则：括号列不转换
    if (/\(.*\)/.test(headerText || "")) return `<td>${rawValue}</td>`;

    // ---- weight 列：kg/lbs（支持 ≤ / 区间 / 斤）
    if (header.includes("weight")) {
      const hasKg = /kg/i.test(raw);

      const le = dashNormalize(raw).match(/^≤\s*([\d.]+)/);
      if (le) {
        let kg = normalizeWeightKg(parseFloat(le[1]), hasKg);
        const lbs = kgToLbs(kg);
        return `<td data-kg="≤${kg}" data-lbs="≤${lbs}">${unit === "cm" ? `≤${kg} kg` : `≤${lbs} lbs`}</td>`;
      }

      const pr = parseRangeOrNumber(raw.replace(/kg/gi, ""));
      if (pr?.type === "range") {
        let a = normalizeWeightKg(pr.a, hasKg);
        let b = normalizeWeightKg(pr.b, hasKg);
        const lbsA = kgToLbs(a);
        const lbsB = kgToLbs(b);
        return `<td data-kg="${a}-${b}" data-lbs="${lbsA}-${lbsB}">${unit === "cm" ? `${a}-${b} kg` : `${lbsA}-${lbsB} lbs`}</td>`;
      }
      if (pr?.type === "single") {
        let kg = normalizeWeightKg(pr.a, hasKg);
        const lbs = kgToLbs(kg);
        return `<td data-kg="${kg}" data-lbs="${lbs}">${unit === "cm" ? `${kg} kg` : `${lbs} lbs`}</td>`;
      }
      return `<td>${rawValue}</td>`;
    }

    // ---- height 列：cm / ft'in"（支持区间）
    if (header.includes("height")) {
      const pr = parseRangeOrNumber(raw.replace(/cm/gi, ""));
      if (pr?.type === "range") {
        const ftin = cmRangeToFtInRange(pr.a, pr.b);
        return `<td data-cm="${pr.a}-${pr.b}" data-ftin="${ftin}">${unit === "cm" ? `${pr.a}-${pr.b} cm` : ftin}</td>`;
      }
      if (pr?.type === "single") {
        const ftin = cmToFtIn(pr.a);
        return `<td data-cm="${pr.a}" data-ftin="${ftin}">${unit === "cm" ? `${pr.a} cm` : ftin}</td>`;
      }
      return `<td>${rawValue}</td>`;
    }

    // ---- 默认长度：cm/in（支持区间）
    const pr = parseRangeOrNumber(raw.replace(/cm/gi, ""));
    if (pr?.type === "range") {
      const inRange = cmRangeToInRange(pr.a, pr.b);
      return `<td data-cm="${pr.a}-${pr.b}" data-inch="${inRange}">${unit === "cm" ? `${pr.a}-${pr.b} cm` : `${inRange} in`}</td>`;
    }
    if (pr?.type === "single") {
      const inch = cmToIn(pr.a);
      return `<td data-cm="${pr.a}" data-inch="${inch}">${unit === "cm" ? `${pr.a} cm` : `${inch} in`}</td>`;
    }

    return `<td>${rawValue}</td>`;
  }

  function renderSizeTable(title, lines) {
    const headers = (lines[1] || "").split(",").map(h => h.trim());
    const rows = lines.slice(2).map((r) => {
      if (r.includes(":")) {
        const [size, values] = r.split(":");
        return [size.trim(), ...values.split(/[\/,]/).map(v => v.trim())];
      }
      return r.split(",").map(c => c.trim());
    });

    let html = `<div class="size-chart-block"><p style="text-transform:capitalize; font-size:18px;">${title}</p>`;
    html += `<table class="size-model-table" data-type="size"><thead><tr>${headers.map(thWithMeta).join("")}</tr></thead><tbody>`;

    rows.forEach((row) => {
      html += `<tr>`;
      row.forEach((cell, idx) => {
        if (idx === 0) {
          html += `<td>${cell}</td>`;
        } else {
          html += renderCellByHeader(cell, headers[idx] || "");
        }
      });
      html += `</tr>`;
    });

    html += `</tbody></table></div>`;
    return html;
  }

  // =========================
  // ✅ renderModelTable：增量修复
  // - 修复 Height / Weight（带空格）识别 + 斤->kg
  // - 修复 Bust / Waist / Hip 三项显示：每项带单位
  // - 修复 Height/Weight & B/W/H 表头：INCH 下加 (FT/IN, LBS) / (IN)
  // =========================
  function renderModelTable(lines, isTryOn = false) {
    const headerIdx = isTryOn ? 1 : (lines[0].includes(",") ? 0 : 1);
    const headers = (lines[headerIdx] || "").split(",").map(h => h.trim());
    const rows = lines.slice(headerIdx + 1).map(r => r.split(",").map(c => c.trim()));

    let html = `<div class="size-chart-block" style="margin-top:20px;">
      <p style="text-transform:capitalize; font-size:18px;">${isTryOn ? "Try-On Report" : "Model Info"}</p>
      <table class="size-model-table" data-type="model"><thead><tr>${headers.map(thWithMeta).join("")}</tr></thead><tbody>`;

    rows.forEach((row) => {
      html += `<tr>`;
      row.forEach((cell, idx) => {
        const headerRaw = headers[idx] || "";
        const header = headerRaw.toLowerCase();
        const headerNorm = header.replace(/\s+/g, "");

        // Height / Weight 复合列（160 / 100 => 160cm / 50kg）
        if (headerNorm.includes("height/weight") || headerNorm.includes("heightweight")) {
          const parts = String(cell).split("/").map(p => p.trim());
          if (parts.length === 2) {
            let cm = parseFloat(parts[0].replace(/[^\d.]/g, ""));
            let w = parseFloat(parts[1].replace(/[^\d.]/g, ""));

            const hasKg = /kg/i.test(cell);
            w = normalizeWeightKg(w, hasKg);

            const lbs = kgToLbs(w);
            const dispH = cmToFtIn(cm);

            html += `<td data-cm="${cm}" data-kg="${w}" data-ftin="${dispH}" data-lbs="${lbs}" data-merge="true">
              ${unit === "cm" ? `${cm} cm / ${w} kg` : `${dispH} / ${lbs} lbs`}
            </td>`;
            return;
          }
        }

        // height 单值
        if (header.includes("height")) {
          const cm = parseFloat(String(cell).replace(/[^\d.]/g, ""));
          if (!isNaN(cm)) {
            const dispH = cmToFtIn(cm);
            html += `<td data-cm="${cm}" data-ftin="${dispH}">${unit === "cm" ? `${cm} cm` : dispH}</td>`;
            return;
          }
        }

        // weight 单值（支持斤）
        if (header.includes("weight")) {
          let w = parseFloat(String(cell).replace(/[^\d.]/g, ""));
          const hasKg = /kg/i.test(cell);
          w = normalizeWeightKg(w, hasKg);
          if (!isNaN(w)) {
            const lbs = kgToLbs(w);
            html += `<td data-kg="${w}" data-lbs="${lbs}">${unit === "cm" ? `${w} kg` : `${lbs} lbs`}</td>`;
            return;
          }
        }

        // Bust / Waist / Hip（每项带单位）
        if (
          header.includes("bwh") ||
          header.includes("b/w/h") ||
          header.includes("bust/waist/hip") ||
          header.includes("bust/waist/hips") ||
          (header.includes("bust") && header.includes("waist") && header.includes("hip"))
        ) {
          const cleaned = String(cell).replace(/cm/gi, "").trim();
          const parts = cleaned.split("/").map(s => s.trim()).filter(Boolean);

          if (parts.length === 3) {
            const [b, w, h] = parts.map(x => parseFloat(x.replace(/[^\d.]/g, "")));
            if (![b, w, h].some(v => isNaN(v))) {
              const bIn = (b / 2.54).toFixed(1);
              const wIn = (w / 2.54).toFixed(1);
              const hIn = (h / 2.54).toFixed(1);

              html += `<td data-bwh-cm="${b}/${w}/${h}" data-bwh-in="${bIn}/${wIn}/${hIn}">
                ${unit === "cm"
                  ? `${b} cm / ${w} cm / ${h} cm`
                  : `${bIn} in / ${wIn} in / ${hIn} in`}
              </td>`;
              return;
            }
          }
        }

        // 其他：用通用规则（不破坏原功能）
        if (idx > 0) {
          html += renderCellByHeader(cell, headerRaw);
          return;
        }

        html += `<td>${cell}</td>`;
      });
      html += `</tr>`;
    });

    html += `</tbody></table></div>`;
    return html;
  }

  // =========================
  // ✅ renderRecommendationTable：兼容两种 recommendation
  // A) 普通 Size 推荐表（Size + Recommended Weight/Height/Bust）
  // B) 旧“身高×体重矩阵”（保留）
  // =========================
  function renderRecommendationTable(lines) {
    const headers = (lines[1] || "").split(",").map(h => h.trim());
    const rows = lines.slice(2).map(r => r.split(",").map(c => c.trim()));

    const headerText = headers.join(" ").toLowerCase();
    const isSimpleSizeRec =
      headers[0]?.toLowerCase() === "size" &&
      headerText.includes("recommended") &&
      (headerText.includes("weight") || headerText.includes("height") || headerText.includes("bust"));

    // A) 普通 Size 推荐表
    if (isSimpleSizeRec) {
      let html = `<div class="size-chart-block" style="margin-top:20px;">
        <p style="text-transform:capitalize; font-size:18px;">Size Recommendation</p>
        <table class="size-model-table" data-type="recommendation-simple">
          <thead><tr>${headers.map(thWithMeta).join("")}</tr></thead><tbody>`;

      rows.forEach((row) => {
        html += `<tr>`;
        row.forEach((cell, idx) => {
          if (idx === 0) {
            html += `<td>${cell}</td>`;
            return;
          }
          html += renderCellByHeader(cell, headers[idx] || "");
        });
        html += `</tr>`;
      });

      html += `</tbody></table></div>`;
      return html;
    }

    // B) 旧矩阵表（保持）
    let html = `<div class="size-chart-block" style="margin-top:20px;">
      <p style="text-transform:capitalize; font-size:18px;">Size Recommendation</p>
      <table class="size-model-table" data-type="recommendation">
        <thead><tr>`;

    headers.forEach((h, idx) => {
      if (idx === 0) {
        html += `<th data-raw="${h.replace(/"/g, "&quot;")}" data-kind="height">${h}</th>`;
      } else {
        html += thWithMeta(h);
      }
    });

    html += `</tr></thead><tbody>`;

    rows.forEach((row) => {
      html += `<tr>`;
      row.forEach((cell, idx) => {
        if (idx === 0) {
          html += `<td>${cell}</td>`;
          return;
        }
        html += `<td>${cell}</td>`;
      });
      html += `</tr>`;
    });

    html += `</tbody></table></div>`;
    return html;
  }

  // =========================
  // ✅ switchUnit：增强 td/th 切换
  // - 修复你截图里的问题：FITS WEIGHT(KG) 在 inch 下仍显示 in
  // =========================
  function switchUnit(newUnit) {
    unit = newUnit;
    const btnCm = document.getElementById("btn-cm");
    const btnInch = document.getElementById("btn-inch");
    if (btnCm && btnInch) {
      btnCm.style.background = unit === "cm" ? "#000" : "#fff";
      btnCm.style.color = unit === "cm" ? "#fff" : "#000";
      btnInch.style.background = unit === "in" ? "#000" : "#fff";
      btnInch.style.color = unit === "in" ? "#fff" : "#000";
    }

    // td 切换（优先级：merge > bwh > weight > height > length）
    document.querySelectorAll("#size-chart-body td").forEach((td) => {
      // merged height/weight
      if (td.dataset.merge === "true" && td.dataset.cm && td.dataset.kg && td.dataset.ftin && td.dataset.lbs) {
        td.innerText = unit === "cm"
          ? `${td.dataset.cm} cm / ${td.dataset.kg} kg`
          : `${td.dataset.ftin} / ${td.dataset.lbs} lbs`;
        return;
      }

      // BWH（三项）
      if (td.dataset.bwhCm && td.dataset.bwhIn) {
        const cmParts = td.dataset.bwhCm.split("/").map(x => x.trim());
        const inParts = td.dataset.bwhIn.split("/").map(x => x.trim());
        td.innerText = unit === "cm"
          ? `${cmParts[0]} cm / ${cmParts[1]} cm / ${cmParts[2]} cm`
          : `${inParts[0]} in / ${inParts[1]} in / ${inParts[2]} in`;
        return;
      }

      // weight kg <-> lbs（包含 ≤ / range 的字符串）
      if (td.dataset.kg && td.dataset.lbs && !td.dataset.ftin) {
        td.innerText = unit === "cm" ? `${td.dataset.kg} kg` : `${td.dataset.lbs} lbs`;
        return;
      }

      // Height cm <-> ft'in"
      if (td.dataset.cm && td.dataset.ftin) {
        td.innerText = unit === "cm" ? `${td.dataset.cm} cm` : td.dataset.ftin;
        return;
      }

      // length cm <-> in
      if (td.dataset.cm && td.dataset.inch) {
        td.innerText = unit === "cm" ? `${td.dataset.cm} cm` : `${td.dataset.inch} in`;
        return;
      }
    });

    // th 表头切换（按 kind，自动加单位）
    document.querySelectorAll("#size-chart-body table").forEach((table) => {
      table.querySelectorAll("thead th").forEach((th) => {
        const raw = th.dataset.raw ? th.dataset.raw.replace(/&quot;/g, '"') : th.innerText;
        const kind = (th.dataset.kind || "").toLowerCase();
        const rawClean = raw.trim();

        if (unit === "cm") {
          th.innerText = rawClean;
          return;
        }

        // ✅ weight：把 (KG) 改成 (LBS)
        if (kind === "weight") {
          const base = rawClean.replace(/\(\s*kg\s*\)/ig, "").trim();
          th.innerText = `${base} (LBS)`;
          return;
        }

        // ✅ height：把 (CM) 改成 (FT/IN)
        if (kind === "height") {
          const base = rawClean.replace(/\(\s*cm\s*\)/ig, "").trim();
          th.innerText = `${base} (FT/IN)`;
          return;
        }

        // ✅ 特例：Height / Weight 复合列（Try-On Report）
        if (rawClean.toLowerCase().replace(/\s+/g, "") === "height/weight") {
          th.innerText = "HEIGHT / WEIGHT (FT/IN, LBS)";
          return;
        }

        // ✅ 特例：Bust / Waist / Hip（Try-On Report）
        if (rawClean.toLowerCase().replace(/\s+/g, "") === "bust/waist/hip") {
          th.innerText = "BUST / WAIST / HIP (IN)";
          return;
        }

        // len/text：保持原样
        th.innerText = rawClean;
      });
    });

    updateContainerHeight();
  }

  // Tabs 动画（你原逻辑）
  tabs.forEach((btn) => {
    btn.addEventListener("click", () => {
      const targetId = btn.dataset.target;
      const targetPage = document.getElementById(targetId);
      if (!targetPage || targetPage === activePage || isAnimating) return;

      tabs.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      isAnimating = true;

      const clean = (el) =>
        el.classList.remove(
          "slide-out-left",
          "slide-out-right",
          "slide-in-left",
          "slide-in-right"
        );
      clean(activePage);
      clean(targetPage);

      const goingLeft = targetId === "measuring";
      targetPage.style.display = "block";
      requestAnimationFrame(() => {
        updateContainerHeight(targetPage);
      });

      activePage.classList.remove("active");
      activePage.classList.add(
        goingLeft ? "slide-out-left" : "slide-out-right"
      );

      const onOutEnd = () => {
        activePage.removeEventListener("animationend", onOutEnd);
        activePage.style.display = "none";
        activePage.classList.remove("slide-out-left", "slide-out-right");

        targetPage.classList.add(goingLeft ? "slide-in-right" : "slide-in-left");

        const onInEnd = () => {
          targetPage.removeEventListener("animationend", onInEnd);
          targetPage.classList.remove("slide-in-left", "slide-in-right");
          targetPage.classList.add("active");
          activePage = targetPage;
          isAnimating = false;
          updateContainerHeight();
        };
        targetPage.addEventListener("animationend", onInEnd, { once: true });
      };
      activePage.addEventListener("animationend", onOutEnd, { once: true });
    });
  });

  window.addEventListener("resize", () => updateContainerHeight());

  // Drawer edge drag（你原逻辑）
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  const threshold = 80;
  const edgeWidth = 40;
  const drawer = document.getElementById("size-chart-drawer");
  const overlayEl = document.getElementById("size-chart-overlay");

  if (drawer) {
    drawer.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      if (startX > edgeWidth) {
        isDragging = false;
        return;
      }
      isDragging = true;
      drawer.style.transition = "none";
    });

    drawer.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      const diffX = currentX - startX;
      if (diffX > 0) {
        drawer.style.transform = `translateX(${diffX}px)`;
      }
    });

    drawer.addEventListener("touchend", () => {
      if (!isDragging) return;
      isDragging = false;

      const diffX = currentX - startX;
      drawer.style.transition = "transform 0.3s ease";

      if (diffX > threshold) {
        drawer.classList.remove("open");
        if (overlayEl) overlayEl.classList.remove("open");
        drawer.style.transform = "";
      } else {
        drawer.style.transform = "translateX(0)";
        setTimeout(() => {
          drawer.style.transition = "";
          drawer.style.transform = "";
        }, 300);
      }
    });
  }

  // table wrapper (scroll)（你原逻辑）
  const wrapTables = () => {
    const tables = document.querySelectorAll(".size-chart-block table");
    tables.forEach(table => {
      if (!table.parentElement.classList.contains("size-chart-table-wrapper")) {
        const wrapper = document.createElement("div");
        wrapper.className = "size-chart-table-wrapper";
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });
  };

  wrapTables();

  const oldRender = renderSizeChart;
  renderSizeChart = function () {
    oldRender.apply(this, arguments);
    wrapTables();
  };
});
